var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0841 4.17304H11.9976V2.86895C11.9976 2.29352 11.5298 1.82568 10.9543 1.82568H5.73799C5.16256 1.82568 4.69472 2.29352 4.69472 2.86895V4.17304H2.60818C2.31965 4.17304 2.08655 4.40614 2.08655 4.69467V5.21631C2.08655 5.28803 2.14523 5.34672 2.21696 5.34672H3.20154L3.60418 13.8722C3.63026 14.4281 4.08995 14.8665 4.64582 14.8665H12.0465C12.604 14.8665 13.0621 14.4297 13.0881 13.8722L13.4908 5.34672H14.4754C14.5471 5.34672 14.6058 5.28803 14.6058 5.21631V4.69467C14.6058 4.40614 14.3727 4.17304 14.0841 4.17304ZM10.8239 4.17304H5.8684V2.99936H10.8239V4.17304Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFilled);
export default __webpack_public_path__ + "static/media/deleteFilled.8fcbfe4c8f917b85520ec2adea22e096.svg";
export { ForwardRef as ReactComponent };